import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import uploadImageRequest from '../image-uploader/ImageUploader.api';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { CompanyResponseDto } from './dto/response/get-companies-response.dto';
import { UpdateCompanyRequestDto } from './dto/request/update-company.request.dto';
import { UpdateCompanyResponseDto } from './dto/response/update-company.response.dto';
import { UpdateUserStatusRequestDto } from './dto/request/update-user-status.request.dto';
import { GetCompanyUsersResponseDto } from './dto/response/get-company-users-response.dto';
import { GetCompanyByIdResponseDto } from './dto/response/get-companies-by-id-response.dto';
import { GetUsersForGuestsResponseDto } from './dto/response/get-users-for-guests-response.dto';
import { UpdateUserPermissionRequestDto } from './dto/request/update-user-permission.request.dto';

const USERS_PATH = HttpPathsEnum.USERS;
const COMPANY_PATH = HttpPathsEnum.COMPANY;

class CompanyManagementApi {
  public async getCompanies(scope?: number) {
    const request: HttpRequest = {
      url: `${COMPANY_PATH}/company/all`,
      method: RequestType.GET,
      params: {
        scope: scope ? scope : undefined,
      },
    };

    return await AppHttpClient.exec<any, CompanyResponseDto[]>(
      request,
      CompanyResponseDto
    );
  }

  public async updateCompany(data: UpdateCompanyRequestDto) {
    const request: HttpRequest = {
      url: `${COMPANY_PATH}/company/my-company`,
      method: RequestType.PATCH,
      data,
    };

    return await AppHttpClient.exec<
      UpdateCompanyRequestDto,
      UpdateCompanyResponseDto
    >(request, UpdateCompanyResponseDto);
  }

  public async getMyCompany() {
    const request: HttpRequest = {
      url: `${COMPANY_PATH}/company/my-company`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCompanyByIdResponseDto>(
      request,
      GetCompanyByIdResponseDto
    );
  }

  public async uploadCompanyImage(data: any) {
    return await uploadImageRequest(
      `${COMPANY_PATH}/upload/upload-image`,
      data
    );
  }

  public async getAllCompanyUsersPermissions() {
    const request: HttpRequest = {
      url: `${USERS_PATH}/permissions/all`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCompanyUsersResponseDto[]>(
      request,
      GetCompanyUsersResponseDto
    );
  }

  public async updateUserPermission(
    userId: number,
    data: UpdateUserPermissionRequestDto
  ) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/permissions/update/${userId}`,
      method: RequestType.PATCH,
      data,
    };

    return await AppHttpClient.exec<
      UpdateUserPermissionRequestDto,
      GetCompanyUsersResponseDto[]
    >(request, GetCompanyUsersResponseDto);
  }

  public async updateUserStatus(id: number, data: UpdateUserStatusRequestDto) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/company-owner/set-user-status/${id}`,
      method: RequestType.PUT,
      data,
    };

    return await AppHttpClient.exec<UpdateUserStatusRequestDto, boolean>(
      request,
      Boolean
    );
  }

  public async getCompanyUsers() {
    const request: HttpRequest = {
      url: `${USERS_PATH}/users/my-company`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetUsersForGuestsResponseDto[]>(
      request,
      GetUsersForGuestsResponseDto
    );
  }

  public async generateInvitationLink() {
    const request: HttpRequest = {
      url: `${COMPANY_PATH}/company/invite-link/my-company`,
      method: RequestType.POST,
    };

    return await AppHttpClient.exec<any, string>(request, String);
  }
}

export default new CompanyManagementApi();
